import React from 'react'
import { Link } from 'react-router-dom'

// helpers
import { toSentence } from 'lib/helpers/lists'

// material ui
import Box from '@mui/material/Box'

// components
import Typography from '@mui/material/Typography'
import AccountButton from 'components/atoms/AccountButton'

const RegisterButton = props => {
  const { account } = props
  const { registrationStatus } = account
  const {
    validCampers,
    validParents,
    validEmergencyContacts,
    validPickupPeople
  } = registrationStatus

  // don't enable button if campers or adults still need to be confirmed
  const disabled = !(
    validCampers &&
    validParents &&
    validEmergencyContacts &&
    validPickupPeople
  )

  // display a list of what still needs to be confirmed
  const invalidList = [
    !validCampers && 'campers',
    !validParents && 'parents',
    !validEmergencyContacts && 'emergency contacts',
    !validPickupPeople && 'pick-up people'
  ].filter(t => !!t)

  return (
    <Box align='center' my={4}>
      {disabled && (
        <Typography variant='body1' align='center' my={2}>
          Please confirm {toSentence(invalidList)} to continue.
        </Typography>
      )}
      <AccountButton
        variant='contained'
        color='secondary'
        component={Link}
        to='/plans/cart'
        disabled={disabled}
      >
        Register
      </AccountButton>
    </Box>
  )
}

export default RegisterButton
